"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerSectionContainer = exports.CrumblistContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var styled_components_1 = __importDefault(require("styled-components"));
var common_1 = require("../../../components/common");
exports.CrumblistContainer = (0, styled_components_1.default)(aon_tws_common_ui_1.Crumblist)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-top: 10px;\n"], ["\n\tdisplay: block;\n\tmargin-top: 10px;\n"])));
exports.CrumblistContainer.displayName = 'CrumblistContainer';
var InnerSectionContainerCss = "\n\tpadding: 10px 30px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-bottom: 15px;\n\t}\n";
exports.InnerSectionContainer = (0, styled_components_1.default)(common_1.Col3Col9)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), InnerSectionContainerCss);
exports.InnerSectionContainer.displayName = 'InnerSectionContainer';
var templateObject_1, templateObject_2;
